/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreditCardTokenDetail } from './creditCardTokenDetail';

export interface CreditCard {
  cardIDMercadoPago?: string;
  cardToken?: string;
  cpf?: number;
  creditCardFlagId?: number;
  creditCardId?: number;
  customerIDMercadoPago?: string;
  cvv?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  deviceId?: string;
  expMonth?: number;
  expYear?: number;
  firstDigits?: string;
  lastDigits?: string;
  nameOnCard?: string;
  number?: number;
  pagarmeCardToken?: string;
  personId?: number;
  securityCode?: string;
  subscriberId?: number;
  tokens?: Array<CreditCardTokenDetail>;
}
